<template>
  <div class="destak-card">
    <section @mouseenter="mouseEnter = true" @mousemove="mouseEnter = true"
             @click="handleFullScreen" @mouseout="mouseEnter = false" class="cursor">
      <md-card class="m-0 md-elevation-6">
        <md-card-media-cover md-solid>
          <md-card-media md-ratio="1:1">
            <img :src="image" :alt="title">
          </md-card-media>

          <md-card-area class="d-lg-flex d-none">
            <md-card-header v-if="!mouseEnter" @mouseenter="mouseEnter = true">
              <span class="md-title">{{ title | truncate(26) }}</span>
              <span class="md-subhead">{{ subtitle | truncate(120) }}</span>
            </md-card-header>

            <md-card-actions>
              <div class="d-flex flex-grow-1">
                <i class="material-icons ml-1">date_range</i>
                <span class="ml-2 m-0">{{ formatedDate() }}</span>
              </div>
              <!--<md-button @click="handleFullScreen" class="md-icon-button">-->
                <!--<md-icon>fullscreen</md-icon>-->
              <!--</md-button>-->
            </md-card-actions>
          </md-card-area>
        </md-card-media-cover>
      </md-card>
    </section>
    <md-dialog :md-active.sync="showDialog" class="w-100 md-scrollbar" md-theme="black">
      <md-dialog-title>{{title}}</md-dialog-title>
      <md-dialog-content>
        <img :src="image" class="rounded mb-4" :alt="title">
        <span class="md-headline">
          {{ subtitle }}
        </span>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Fechar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
  import moment from 'moment'
  import bgNull from '../assets/background/bg_null.jpg'

  moment.locale('pt-br');

  export default {
    name: "DestakCard",
    data() {
      return {
        showDialog: false,
        mouseEnter: false
      }
    },
    props: {
      image: { default: () => bgNull },
      title: { default: 'Titulo' },
      subtitle: { default: 'Sub Titulo' },
      date: { default: () => new Date() }
    },
    methods: {
      formatedDate() {
        return moment(this.date).format('L')
      },
      handleFullScreen() {
        this.showDialog = true
      }
    }

  }
</script>

<style scoped>
  .cursor {
    cursor: pointer;
  }
</style>
